import Navbar from '../../../components/NavbarUnauthenticated';
import PropTypes from 'prop-types';
import Box from '../../../components/Box';
import {FormattedMessage} from 'react-intl';
import messages from '../messages';
import React from 'react';

export const ResetPasswordWrapper = (props) => {
    const boxStyle = {
        maxWidth: '440px',
        minHeight: '480px',
        padding: '36px 60px'
    };

    const h1Style = {
        marginBottom: '48px',
        textAlign: 'center'
    };

    return (
        <section className="hero is-fullheight alva-bg">
            <Navbar/>

            <div className="hero-body">
                <div className="container">
                    <Box isCentered={true} style={boxStyle}>
                        <h1 className="title" style={h1Style}><FormattedMessage {...messages.title}/></h1>
                        {props.children}
                    </Box>
                </div>
            </div>
        </section>
    );
};

ResetPasswordWrapper.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.element, PropTypes.array
    ])
};
